import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, QueryParamsHandling } from '@angular/router';

import { TitleService } from '~/core/services/title/title.service';
import { OrganizerSharedPageAbstract } from '~/organizer/shared/components/pages/abstract/page.abstract';

import { OrganizerSharedPageInformationPageInterface } from './interfaces/page.interface';

@Component({
  selector: 'app-organizer-shared-page-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})
export class OrganizerSharedPageInformationComponent extends OrganizerSharedPageAbstract<OrganizerSharedPageInformationPageInterface> {
  protected readonly pageCssClass = 'organizer-shared-page-information';
  public descriptionKey: string;
  public imageSource: string;
  public mobileImageSource: string;
  public previousQueryParametersHandling: QueryParamsHandling = 'preserve';
  public titleKey: string;

  constructor(
    protected readonly activatedRoute: ActivatedRoute,
    protected readonly location: Location,
    protected readonly titleService: TitleService
  ) {
    super(activatedRoute, location, titleService);
  }

  protected getPagesConfig(): {
    [key: string]: OrganizerSharedPageInformationPageInterface;
  } {
    return {
      'organizer.onboarding.welcome': {
        descriptionKey: 'onboarding.welcome.text',
        imageSource: 'assets/organizer/onboarding/welcome/background.jpg',
        layoutCssClass: 'organizer-onboarding-page-welcome',
        mobileImageSource: 'assets/organizer/onboarding/welcome/mobile.jpg',
        pageTitleKey: 'seo.organizer.onboarding.welcome.title',
        previousQueryParametersHandling: '' as QueryParamsHandling,
        titleKey: 'onboarding.welcome.title',
      },
      'organizer.activity-creation.welcome': {
        descriptionKey: 'activity_creation.welcome.text',
        imageSource:
          'assets/organizer/activity-creation/welcome/background.jpg',
        layoutCssClass: 'organizer-activity-creation-page-welcome',
        mobileImageSource:
          'assets/organizer/activity-creation/welcome/mobile.jpg',
        pageTitleKey: 'seo.organizer.activity_creation.welcome.title',
        previousQueryParametersHandling: '' as QueryParamsHandling,
        titleKey: 'activity_creation.welcome.title',
      },
    };
  }

  public setPageValues(
    pageConfig: OrganizerSharedPageInformationPageInterface
  ): void {
    this.pageTitleKey = pageConfig.pageTitleKey;

    this.descriptionKey = pageConfig.descriptionKey;
    this.imageSource = pageConfig.imageSource;
    this.mobileImageSource = pageConfig.mobileImageSource;
    this.previousQueryParametersHandling =
      this.previousQueryParametersHandling ??
      pageConfig.previousQueryParametersHandling;
    this.titleKey = pageConfig.titleKey;
  }
}
